export const TranslatedComponent = {
	data: () => ({
		langs: [
			'da',
			'de',
			'en'
		],
	}),
	computed: {
		language() {
			return this.$route.params.language;
		},
		root() {
			return '/' + this.language + '/';
		},
	},
	methods: {
		updateLangs( langs ) {
			this.langs = langs;
			this.$emit('updatelangs', langs);
		},
		changeLanguage: function( language ) {
			const route = this.$router.currentRoute;
			const path = route.path;
			const newPath = path.replace( /^\/[^\/]+\//, `/${language}/` );

			this.$router.replace({ path: newPath });
		},
	},
};



// WEBPACK FOOTER //
// ./assets/_js/mixins/translated-component.js